/**
 * Utility to import ACS project data into the application
 */

import { saveState } from '../store';
import { intellesphereOrg, intellesphereUsers, acsProject, acsEpics, acsTasks } from '../samples/acsProjectData';
import { useApp } from '../providers/AppProvider';

export const importACSProject = () => {
  const { state } = useApp();
  
  // Check if organization already exists
  const existingOrg = state.organizations.find(o => o.id === intellesphereOrg.id);
  if (existingOrg) {
    console.log('Intellesphere organization already exists');
    return { success: false, message: 'Organization already exists' };
  }
  
  // Add organization
  state.organizations.push(intellesphereOrg);
  
  // Add users (only if they don't exist)
  intellesphereUsers.forEach(user => {
    const existingUser = state.users.find(u => u.id === user.id);
    if (!existingUser) {
      state.users.push(user);
    }
  });
  
  // Add project
  state.projects.push(acsProject);
  
  // Add epics
  acsEpics.forEach(epic => {
    state.epics.push(epic);
  });
  
  // Add tasks and update epic taskIds
  acsTasks.forEach(task => {
    state.tasks.push(task);
    
    // Update epic with task ID
    if (task.epicId) {
      const epic = state.epics.find(e => e.id === task.epicId);
      if (epic && !epic.taskIds.includes(task.id)) {
        epic.taskIds.push(task.id);
      }
    }
  });
  
  // Save state
  saveState(state);
  
  console.log('✅ ACS Project imported successfully!');
  console.log(`📦 Added: 1 organization, ${intellesphereUsers.length} users, 1 project, ${acsEpics.length} epics, ${acsTasks.length} tasks`);
  
  return { 
    success: true, 
    message: 'ACS Project imported successfully',
    stats: {
      organizations: 1,
      users: intellesphereUsers.length,
      projects: 1,
      epics: acsEpics.length,
      tasks: acsTasks.length,
    }
  };
};
